import Vue from "vue";
import VueRouter from "vue-router";
import VueLocalForage from "vue-localforage";

const Login = () =>
  import("@/components/Login");
const Dashboard = () =>
  import("@/components/Dashboard");
const Saldo = () =>
  import("@/components/Saldo");
const Extrato = () =>
  import("@/components/Extrato");
const Lojas = () =>
  import("@/components/Lojas");
const Logout = () =>
  import("@/components/Logout");
const ResetSenha = () =>
  import("@/components/ResetSenha");
  const Removerconta = () =>
  import("@/components/Removerconta");
const Privacidade = () =>
  import("@/components/Privacidade");
Privacidade

Vue.use(VueRouter);
Vue.use(VueLocalForage);

const routes = [{
    path: "/lojas",
    name: "Lojas",
    component: Lojas
  },
  {
    path: "/",
    name: "Index"
  },
  {
    path: "/login",
    name: "Login",
    component: Login
  },
  {
    path: "/bemvindo",
    name: "Bemvindo",
    component: Dashboard
  },
  {
    path: "/removerconta/:cpf",
    name: "Removerconta",
    component: Removerconta
  },
  {
    path: "/privacidade",
    name: "Privacidade",
    component: Privacidade
  }, ,
  {
    path: "/saldo",
    name: "Saldo",
    component: Saldo
  },
  {
    path: "/extrato",
    name: "Extrato",
    component: Extrato
  },
  {
    path: "/logout",
    name: "Logout",
    component: Logout
  },
  {
    path: "/resetSenha/:id_token",
    props: true,
    name: "ResetSenha",
    component: ResetSenha
  }
];

const router = new VueRouter({
  mode: "history",
  routes,
  suppressTransitionError: false
});

router.beforeEach(async (to, from, next) => {
  console.log(to);
  if (to.name == "ResetSenha") {
    await window.sessionStorage.setItem("menu", false);

    next();

    return false;
  }
  if (to.name == "Privacidade" || to.name == "Removerconta" ) {
    await window.sessionStorage.setItem("menu", false);

    next();

    return false;
  }
  if (to.name == "Bemvindo") {
    await window.sessionStorage.setItem("menu", false);

    next();

    return false;
  }
  if (to.name == null) {
    next({
      name: "Login"

    });

    return false;
  }
  if (to.name !== "Login" && to.name !== "Index" && to.name !== "Logout") {
    await window.sessionStorage.setItem("menu", true);

    if (window.sessionStorage.getItem("token") !== "") {
      next();
    } else {
      window.sessionStorage.setItem("menu", false);
      next({
        name: "Login"
      });
    }
  } else {
    if (to.name === "Index") {
      next({
        name: "Login"
      });
    } else {
      window.sessionStorage.setItem("menu", false);
      next();
    }
  }
});

export default router;
/*if (window.sessionStorage.getItem("token")) {
      window.sessionStorage.setItem("menu", true);
      next();
      return;
    }
    window.sessionStorage.setItem("menu", false);
    next({ name: "Login" });
    return;
    //.logado = false;
  } else {
    window.sessionStorage.setItem("menu", false);
    next({ name: "Login" });
    return;
  }*/



// WEBPACK FOOTER //
// ./src/router/index.js